import { db } from "@/firebase/init"

export default {
    namespaced: true,
    state: {
        plans: []
    },
    getters: {
        list(state) {
            return state.plans
        }
    },
    mutations: {
        fetchDataMutate(state, payload) {
            state.plans = payload;
        }
    },
    actions: {
        fetchPlans(context) {
            db.collection("plans").orderBy('order').get()
            .then(snapshot => {
                let plans = [];
                console.log('Fetching plans');
                snapshot.forEach((doc) => {
                    plans.push({
                        docID: context.rootGetters.getUID,
                        ...doc.data()
                    });
                });
                console.log(plans);

                context.commit("fetchDataMutate", plans)
            })
        }
    }
}
